import styled from "styled-components";

import { flexColumn, rem } from "@styles/Utilities.styled";


export const StyledNotificationHistoryModal = styled.div`
  ${flexColumn}
  gap: ${rem(16)};
  padding-bottom: ${rem(16)};

  .notification-item {
    padding: ${rem(12)};
    border: 1px solid var(--mantine-color-gray-3);
    border-radius: var(--border-radius-2);
    background-color: var(--mantine-color-gray-0);
    
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .details {
    font-size: ${rem(13)};
    color: var(--mantine-color-dimmed);
  }

  .attempts {
    margin-top: ${rem(8)};
    padding-left: ${rem(12)};
    border-left: 2px solid var(--mantine-color-gray-4);
  }
`;
